import { createContext } from '@lyearn/core/utils/context';

export interface HeaderContextType {
  isSearchOpen: boolean;
  toggleSearchBar: (nextValue: boolean) => void;
  showSearchBar: () => void;
  hideSearchBar: () => void;
}

const [HeaderContextProvider, useHeaderContext] = createContext<HeaderContextType>('HeaderContext');

export { HeaderContextProvider, useHeaderContext };
